export enum SLICE {
  SETTINGS = 'settings',
  USER = 'user',
  MODALS = 'modals',
  POPOVERS = 'popovers',
  OVERLAYS = 'overlays',
  STATUSES = 'statuses',
  CONTRACT_TYPES = 'contract-types',
  SIZING_METHODS = 'sizing-methods',
  STRIKE_METHODS = 'strike-methods',
  EXPIRY_METHODS = 'expiry-methods',
  TRIGGER_TYPES = 'trigger-types',
  ADAPTERS = 'adapters',
  STRATEGIES = 'strategies',
  STRATEGY = 'strategy',
  SIGNAL = 'signal',
  PAIR = 'pair',
  PAIRS = 'pairs',
  CANDLE_WORKERS = 'candle-workers',
  CANDLE_VALIDATIONS = 'candle-validations',
  CURRENCIES = 'currencies',
  INDICATORS = 'indicators',
  OPERATORS = 'operators',
  CANDLES = 'candles',
}
